import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FloatingActionButtons from './FloatingActionButtons';
import ClientProvider from './client';
export default createDemo(import.meta.url, FloatingActionButtons, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/floating-action-button/demos/floating-action-buttons/FloatingActionButtons.tsx",
    "fileName": "FloatingActionButtons.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport Fab from '@mui/material/Fab';\nimport AddIcon from '@mui/icons-material/Add';\nimport EditIcon from '@mui/icons-material/Edit';\nimport FavoriteIcon from '@mui/icons-material/Favorite';\nimport NavigationIcon from '@mui/icons-material/Navigation';\n\nexport default function FloatingActionButtons() {\n  return (\n    <Box sx={{ '& > :not(style)': { m: 1 } }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Fab color=\"primary\" aria-label=\"add\">\n        <AddIcon />\n      </Fab>\n      <Fab color=\"secondary\" aria-label=\"edit\">\n        <EditIcon />\n      </Fab>\n      <Fab variant=\"extended\">\n        <NavigationIcon sx={{ mr: 1 }} />\n        Navigate\n      </Fab>\n      <Fab disabled aria-label=\"like\">\n        <FavoriteIcon />\n      </Fab>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 26,
        "focusedLines": 13,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport Fab from '@mui/material/Fab';\nimport AddIcon from '@mui/icons-material/Add';\nimport EditIcon from '@mui/icons-material/Edit';\nimport FavoriteIcon from '@mui/icons-material/Favorite';\nimport NavigationIcon from '@mui/icons-material/Navigation';\n\nexport default function FloatingActionButtons() {\n  return (\n    <Box sx={{ '& > :not(style)': { m: 1 } }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Fab color=\"primary\" aria-label=\"add\">\n        <AddIcon />\n      </Fab>\n      <Fab color=\"secondary\" aria-label=\"edit\">\n        <EditIcon />\n      </Fab>\n      <Fab variant=\"extended\">\n        <NavigationIcon sx={{ mr: 1 }} />\n        Navigate\n      </Fab>\n      <Fab disabled aria-label=\"like\">\n        <FavoriteIcon />\n      </Fab>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Fab"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "primary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "aria-label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "add",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "AddIcon"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Fab"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Fab"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "secondary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "aria-label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "edit",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "EditIcon"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Fab"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Fab"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "extended",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "NavigationIcon"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "mr"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            "        Navigate"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Fab"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Fab"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "disabled"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "aria-label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "like",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "FavoriteIcon"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Fab"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 26,
    "focusedLines": 13,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/Fab",
      "@mui/icons-material/Add",
      "@mui/icons-material/Edit",
      "@mui/icons-material/Favorite",
      "@mui/icons-material/Navigation"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
